<template>
  <div class="pageBox">
    <div class="content">
      <div class="applicationBox">
        <el-form
            class="formBox"
            :model="form"
            :rules="rules"
            ref="form"
            label-width="auto"
            :validate-on-rule-change="false"
            label-position="top">
          <el-row>
            <el-col :span="16" :offset="2" :xs="{span:22,offset:0}">
              <div class="formTitle">通用设置</div>
              <div class="formContent">
                <el-form-item prop="linkName">
                  <span slot="label" class="label">链接名称</span>
                  <div class="msg">请填写链接名称，仅用于链接管理。</div>
                  <el-input
                      placeholder="请填写链接名称，15个字以内"
                      v-model.trim="form.linkName"
                      disabled
                      clearable
                  ></el-input>
                </el-form-item>
                <el-form-item prop="apkUrl">
                  <span slot="label" class="label">
                    设置应用的自定义兜底页
                    <a :href="'/documents/'+'5611405056246784'" target="_blank"> <i class="el-icon-question"></i></a>
                    <el-switch
                        class="switch"
                        v-model="value1"
                       >
                    </el-switch>
                    <span>{{ value1 ? '开启' : '关闭' }}</span>
                  </span>
                  <div class="msg">
                    若当前设备无法打开应用商店链接或唤起应用时，统一链接将跳转至
                    <span class="color4285F5 cursor" @click="openImg()">报错页面</span>
                    <br>
                    您也可以根据规则设置
                    <a :href="'/documents/'+'5630896251290624'" target="_blank"><span
                        class="color4285F5">自定义兜底页</span></a>
                  </div>
                  <el-input
                      placeholder="请填写兜底页URL地址，最多500个字符"
                      v-model.trim="form.apkUrl"
                      :disabled="!value1"
                      clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="formTitle">安卓/鸿蒙设置</div>
              <div class="formContent">
                <el-form-item prop='androidDeeplink'>
                  <span slot="label" class="label">
                    设置安卓/鸿蒙的应用唤起路径
                    <a :href="'/documents/'+'5611405056246784'" target="_blank"> <i class="el-icon-question"></i></a>
                    <el-switch
                        class="switch"
                        v-model="value2"
                        >
                    </el-switch>
                    <span>{{ value2 ? '开启' : '关闭' }}</span>
                  </span>
                  <div class="msg">
                    设置后用户能通过统一链接打开应用内的指定页面。
                  </div>
                  <el-input
                      placeholder="请填写deeplink地址，最多500个字符"
                      v-model.trim="form.androidDeeplink"
                      :disabled="!value2"
                      clearable
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item>
                  <span slot="label" class="label">
                    设置自定义归因参数
                    <a :href="'/documents/'+'5611405056246784'" target="_blank" > <i class="el-icon-question"></i></a>
                  </span>
                  <div class="msg">
                    可按照自主定义的逻辑编写归因参数（referrer），各厂商开放平台可直接调取归因的参数。
                  </div>
                  <div class="ascribeList">
                    <div class="ascribeItem">
                      <div slot="label" class="label"><span v-if="value3" class="red" style="margin-right:5px">*</span>流量来源 (source)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="source"
                        :rules="[
                        { required:value3, message: '请填写流量来源，仅支持英文数字，最多10字符',trigger: 'blur'},
                        { max: 100, message: '最大限制100个字', trigger: 'blur' },,           
                      ]">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.source"
                          :disabled="!value3" >
                        </el-input>
                        <div class="msg">用于标识流量来源的参数，例如广告平台、搜索引擎、社交媒体等</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label"><span v-if="value3" class="red" style="margin-right:5px">*</span>流量媒介 (medium)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="medium"
                        :rules="[
                        { required:value3, message: '请填写流量媒体，仅支持英文数字，最多10字符',trigger: 'blur'},
                        { max: 100, message: '最大限制100个字', trigger: 'blur' },,           
                      ]">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.medium"
                          :disabled="!value3" >
                        </el-input>
                        <div class="msg">用于标识流量媒介的参数，例如广告、邮件、社交媒体帖子等。</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label"><span v-if="value3" class="red" style="margin-right:5px">*</span>营销活动 (campaign)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="campaign"
                        :rules="[
                        { required:value3, message: '请填写营销活动，仅支持英文数字，最多10字符',trigger: 'blur'},
                        { max: 100, message: '最大限制100个字', trigger: 'blur' },,           
                      ]">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.campaign"
                          :disabled="!value3" >
                        </el-input>
                        <div class="msg">用于标识流量所属的广告活动或营销活动的参数。</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label">关键词 (term)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="term">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.term"
                          :disabled="!value3" >
                        </el-input>
                        <div class="msg">用于标识用户搜索的关键词的参数。</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label">广告内容 (content)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="content">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.content"
                          :disabled="!value3" >
                        </el-input>
                        <div class="msg">用于标识广告或链接的具体内容的参数，例如不同广告创意、按钮文本等。</div>
                      </el-form-item>
                    </div>
                  </div>
                </el-form-item> -->
              </div>
              <div class="formTitle">iOS设置</div>
              <div class="formContent">
                <el-form-item prop="iosUrl">
                  <span slot="label" class="label">
                    设置iOS的跳转路径
                    <a :href="'/documents/'+'5611405056246784'" target="_blank"> <i class="el-icon-question"></i></a>
                    <el-switch
                        class="switch"
                        v-model="value4"
                       >
                    </el-switch>
                    <span>{{ value4 ? '开启' : '关闭' }}</span>
                  </span>
                  <div class="msg">
                    设置iOS的跳转路径后，iOS设备重定向至您设置的iOS跳转路径，未设置iOS的跳转路径时，iOS设备重定向至报错页面;
                    iOS平台建议使用Universal Links链接，查看
                    <el-link class="color4285F5" href="https://developer.apple.com/ios/universal-links/" target="_blank"
                             :underline="false">Universal Links说明
                    </el-link>
                  </div>
                  <el-input
                      placeholder="请输入Universal Links链接地址，最多500个字符"
                      v-model.trim="form.iosUrl"
                      :disabled="!value4"
                      clearable
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="2" :xs="{span:22,offset:0}">
              <el-form-item>
                <div class="text-center">
                  <el-button
                      class="w200"
                      @click="onGoReturn()">
                    取消
                  </el-button>
                  <el-button
                      type="primary"
                      class="w200"
                      @click="submitForm('form')">
                    提交
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="errorBox" v-if="form.reviewRemark">
          <div class="title">审核未通过原因</div>
          <div class="msg">
            {{ form.reviewRemark }}
          </div>
        </div>
      </div>
    </div>
    <imgDialog ref="imgDialog"></imgDialog>
  </div>
</template>
<script>
import imgDialog from "./dialog/imgDialog.vue";

export default {
  components: {
    imgDialog
  },
  data() {
    const validateUrl = (value, callback, isValid) => {
      if (isValid && !$utils.isValidURL(value)) {
        callback(new Error('请填写合法的URL地址'))
      } else {
        callback();
      }
    }
    let validateApkUrl = (rule, value, callback) => {
      validateUrl(value, callback, this.value1)
    }
    let validateDeeplink = (rule, value, callback) => {
      validateUrl(value, callback, this.value2)
    }
    let validateIosUrl = (rule, value, callback) => {
      validateUrl(value, callback, this.value4)
    }
    return {
      error: "", //提交认证错误信息
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      detail: '', //  详情数据JSON，用于对比新旧表单是否发生更改
      form: {
        appLinkId: "",
        linkName: "", //应用名称
        apkUrl: "", //兜底页
        androidDeeplink: "",//安卓鸿蒙路径
        source: "", //流量来源  
        medium: "", //流量媒介
        campaign: "", //营销活动
        term: "", //关键词
        content: "", //广告内容
        iosUrl: "", //iOS跳转路径
      },
      rules: {
        linkName: [
          {required: true, message: "请填写链接名称", trigger: "blur"},
          {max: 15, message: '最大限制15个字', trigger: 'blur'}
        ],
        apkUrl: [
          {max: 500, message: '最大限制500个字', trigger: 'blur'},
          {validator: validateApkUrl, trigger: 'submit'}
        ],
        androidDeeplink: [
          { max: 500, message: '最大限制500个字', trigger: 'blur' },
          {validator: validateDeeplink, trigger: 'submit'}
        ],
        iosUrl: [
          { max: 500, message: '最大限制500个字', trigger: 'blur' },
          {validator: validateIosUrl, trigger: 'submit'}
        ],
      },
    };
  },
  created() {
    this.queryLinkDetail();
  },
  methods: {
    openImg() {
      this.$refs['imgDialog'].show()
    },
    onGoReturn() {
      this.$msgBox.alertMessageBox({
        title: "离开确认",
        content: '确定放弃编辑内容吗？',
        btnText: '确定',
        cancelText: '取消',
      }).then(data => {
        this.$router.back(-1);
      });
    },
    //链接详情
    queryLinkDetail() {
      this.$apis.consoleSever.queryModifyDetail({
        type: 1,
        appLinkAuditId: this.$route.query.appLinkAuditId,
      }).then((res) => {
        if (res.code == 0) {
          this.form = res.data;
          this.detail = JSON.stringify(this.form)
          this.value1 = Boolean(res.data.apkUrl)
          this.value2 = Boolean(res.data.androidDeeplink)
          this.value4 = Boolean(res.data.iosUrl)
          // window.$store.commit("breadcrumbStore/setKeyBreadcrumb", {
          //   menu: this.$route.meta.key, 
          //   name:res.data.apkName, 
          //   path: this.$route.fullPath, 
          // });
        }
      });
    },

    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$apis.consoleSever.editParams({
            ...this.form,
            apkUrl:this.value1 ? this.form.apkUrl : '',
            androidDeeplink:this.value2 ? this.form.androidDeeplink : '',
            iosUrl:this.value4 ? this.form.iosUrl : '',
          }).then((res) => {
            if (res.code == 0) {
              this.$router.back(-1);
            } else {
              this.$msgBox.alertMessageBox({
                title: "创建失败",
                content: res.message,
                btnText: '好的',
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .content {
    background: #fff;
    box-shadow: $--background-shadow-base;

    .applicationBox {
      display: flex;
      padding: 70px 50px;

      .formBox {
        width: 1000px;

        .formTitle {
          padding: 10px 0;
          margin-bottom: 10px;
          border-bottom: 1px solid #DCDFE6;
          color: #606266;
          font-size: 20px;
          font-weight: bold;
        }

        .formContent {
          /deep/ .el-form-item__label {
            position: relative;
            line-height: 20px;
            font-size: 15px;
            font-weight: bold;
          }

          .msg {
            margin: 5px 0;
            line-height: 26px;
            color: #999;

            .color4285F5 {
              color: #4285F5;
            }
          }

          .switch {
            margin: 0 10px;
            margin-top: -2px;
          }

          .ascribeList {
            .ascribeItem {
              display: flex;

              .formItem {
                flex: 1;
                margin-bottom: 10px;

                /deep/ .el-form-item__error {
                  position: relative;
                  margin-top: -5px;
                }
              }

              .label {
                width: 160px;
                color: #606266;
              }

              .msg {
                margin: 0;
              }
            }
          }
        }
      }

      .errorBox {
        flex: 1;

        .title {
          padding: 10px 0;
          margin-bottom: 10px;
          border-bottom: 1px solid #DCDFE6;
          color: #606266;
          font-size: 20px;
          font-weight: bold;
        }

        .msg {
          line-height: 26px;
        }
      }
    }
  }
}
</style>

